(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/photo-finish.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/photo-finish.js');

'use strict';

const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  Image
} = svs.content.image_v2;
const PhotoFinish = _ref => {
  let {
    trackId,
    formattedDate
  } = _ref;
  const imageOptions = trackId && formattedDate && getImageOptions(trackId, formattedDate, ImageTypes.PhotoFinish);
  return React.createElement("div", {
    className: "photo-finish-holder"
  }, "M\xE5lg\xE5ngsbild", React.createElement(Image, {
    image: imageOptions
  }));
};
svs.racing_game.components.play.PhotoFinish = PhotoFinish;

 })(window);